<div class="estimate-preview-and-sent" *ngIf="estimate && currentEstimateVersion">

  <div class="d-flex gap--12 preview-and-sent-header">
    <div class="header-text">ESTIMATE</div>
    <div class="preview-and-sent-badge"
         *ngIf="badge"
         [class]="badge"
    >
      {{getBadgeCopy(badge)}}
    </div>
  </div>

  <div class="preview-and-sent-content">
    <div class="prepared-by" [style.transform]="'scale(' + (previewScaleFactor$ | async) + ')'">
      <div>
        <div class="text fs14 ln20 ls1">{{currentEstimateVersion.creatorBusinessName}}</div>
        <div class="mt--6 d-flex flex-column gap--4">
          <div class="text">{{currentEstimateVersion.creatorFirstName + ' ' + currentEstimateVersion.creatorLastName}}</div>
          <ng-container *ngIf="currentEstimateVersion.creatorPhoneNumber as phoneNumber"
            [ngTemplateOutlet]="phoneNumberTemplate" [ngTemplateOutletContext]="{ phoneNumber: phoneNumber }">
          </ng-container>
          <div class="text" *ngIf="!sentMode">{{(business$ | async)!.address | address }}</div>
          <div class="text" *ngIf="sentMode">{{ currentEstimateVersion.creatorAddress | address }}</div>
          <div class="text">{{currentEstimateVersion.creatorEmail}}</div>
        </div>
      </div>
      <div [class.d-flex]="(business$ | async)!.logo"
           [class.justify-content-center]="(business$ | async)!.logo"
           [class.width--120]="(business$ | async)!.logo"
      >
        <app-profile-logo [enabled]="false" *ngIf="(business$ | async)!.logo" [noBorder]="true"></app-profile-logo>
        <ng-container *ngIf="!(business$ | async)!.logo" [ngTemplateOutlet]="uid"></ng-container>
      </div>
    </div>

    <div class="prepared-for" [style.transform]="'scale(' + (previewScaleFactor$ | async) + ')'">
      <div>
        <div class="text fs14 ln20 ls1 g700">PREPARED FOR:</div>
        <div class="mt--6 d-flex flex-column gap--4">
          <div class="text">{{currentEstimateVersion.clientBusinessName}}</div>
          <div class="text">
            {{currentEstimateVersion.clientFirstName + ' ' + currentEstimateVersion.clientLastName}}
          </div>
          <ng-container *ngIf="currentEstimateVersion.clientPhoneNumber as phoneNumber"
            [ngTemplateOutlet]="phoneNumberTemplate" [ngTemplateOutletContext]="{ phoneNumber: phoneNumber }">
          </ng-container>
          <div class="text">{{currentEstimateVersion.clientAddress | address }}</div>
          <div class="text" *ngIf="currentEstimateVersion.clientUnit">
            {{currentEstimateVersion.clientUnit}}
          </div>
          <div class="text">{{currentEstimateVersion.clientEmail}}</div>
        </div>
      </div>
      <ng-container *ngIf="(business$ | async)!.logo" [ngTemplateOutlet]="uid"></ng-container>
    </div>

    <ng-template #phoneNumberTemplate let-phoneNumber="phoneNumber">
      <div class="text" *ngIf="!isMobile">{{ phoneNumber | mask: '(000) 000-0000' }}</div>
      <a class="text" *ngIf="isMobile" [href]="'tel:'+phoneNumber">{{ phoneNumber | mask:"(000) 000-0000" }}</a>
    </ng-template>

    <div class="preview-and-sent-data" [style.transform]="'scale(' + (previewScaleFactor$ | async) + ')'">
      <div class="preview-and-sent-note"
           *ngIf="!isEmpty(currentEstimateVersion.note)"
      >
        <div class="label">Estimate Note</div>
        <div class="note-text">{{currentEstimateVersion.note}}</div>
      </div>

      <div class="d-flex flex-column gap--12 w-100" [class.mt--12]="!isEmpty(currentEstimateVersion.note)">
        <div *ngFor="let estimateItem of currentEstimateVersion.items" class="preview-and-sent-item">
          <div class="d-flex gap--22 justify-content-between">
            <div class="name-description">
              <div class="fs14 ln20 ls1 fw-600 cb">{{estimateItem.name}}</div>
              <div class="text fw-400" *ngIf="!isEmpty(estimateItem.description)">{{estimateItem.description}}</div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="d-flex justify-content-between">
            <div class="d-flex gap--48">
              <div class="item-data-block">
                <div class="label">Price</div>
                <div class="data">${{estimateItem.price.toFixed(2)}}</div>
              </div>
              <div class="item-data-block" *ngIf="estimateItem.discountAmount">
                <div class="label">Discount</div>
                <div class="data">-${{estimateItem.discountAmount.toFixed(2)}}</div>
              </div>
              <div class="item-data-block">
                <div class="label">Tax</div>
                <div class="data">
                  ${{ getItemTaxAmount(
                        estimateItem.price,
                        estimateItem.taxable,
                        estimateItem.discountAmount ?? null
                  ).toFixed(2) }}
                </div>
              </div>
              <div class="item-data-block">
                <div class="label">Qty</div>
                <div class="data tac">{{estimateItem.quantity}}</div>
              </div>
            </div>
            <div class="item-data-block">
              <div class="label">Amount</div>
              <div class="data tar">
                ${{ getItemTotal(
                      estimateItem.price,
                      estimateItem.taxable,
                      estimateItem.discountAmount ?? null,
                      estimateItem.quantity ?? null
                ).toFixed(2) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt--40 signature-text pl--16" *ngIf="currentEstimateVersion.signature">Signature</div>
      <div [class.mt--40]="!currentEstimateVersion.signature"
           [class.mt--8]="currentEstimateVersion.signature"
           class="d-flex justify-content-between px--16"
      >
        <div class="d-flex flex-column gap--8">
          <div class="signature-block" *ngIf="currentEstimateVersion.signature"
               [class.signed]="currentEstimateVersion.signatureData?.status === 'signed'"
          >
            <div class="signature-text required" *ngIf="currentEstimateVersion.signatureData?.status !== 'signed'">Required</div>
            <ng-container *ngIf="currentEstimateVersion.signatureData?.status === 'signed'">
              <img [src]="currentEstimateVersion.signatureData?.signatureUrl" alt="signature" width="196px" height="92px">
            </ng-container>
          </div>
          <div class="signature-info" *ngIf="currentEstimateVersion.signatureData?.status === 'signed'">
            Signed by:&nbsp;{{currentEstimateVersion.signatureData.signedBy}}, &nbsp;{{currentEstimateVersion.signatureData.signedAt.toDateString()}}
          </div>
        </div>
        <div class="preview-and-sent-summary">
          <div class="preview-and-sent-summary-data">
            <div class="d-flex flex-column gap--8">
              <div class="d-flex justify-content-between">
                <div class="details">Subtotal</div>
                <div class="details">${{subtotal.toFixed(2)}}</div>
              </div>
              <div class="d-flex justify-content-between">
                <div class="details">Discount</div>
                <div class="details">-${{discount.toFixed(2)}}</div>
              </div>
              <div class="d-flex justify-content-between">
                <div class="details">Sales Tax</div>
                <div class="details">${{salesTax.toFixed(2)}}</div>
              </div>
              <div class="d-flex justify-content-between" *ngIf="currentEstimateVersion.surcharge && estimate?.sSurchargeSum">
                <div class="details">CC Fee</div>
                <div class="details">${{estimate?.sSurchargeSum?.toFixed(2)}}</div>
              </div>
              <div class="d-flex justify-content-between"
                   *ngIf="currentEstimateVersion.depositAmount && currentEstimateVersion.status !== 'canceled'"
              >
                <div class="details">Total</div>
                <div class="details">${{total.toFixed(2)}}</div>
              </div>
            </div>
            <div class="divider"></div>
            <div class="d-flex justify-content-between"
                 *ngIf="!currentEstimateVersion.depositAmount || currentEstimateVersion.status === 'canceled'"
            >
              <div class="total">Total</div>
              <div class="total">${{total.toFixed(2)}}</div>
            </div>
            <div class="d-flex justify-content-between"
                 *ngIf="currentEstimateVersion.depositAmount && currentEstimateVersion.status !== 'canceled'"
            >
              <div class="total">Deposit</div>
              <div class="total">${{(currentEstimateVersion.depositAmount + (estimate.sSurchargeSum ?? 0)).toFixed(2)}}</div>
            </div>
            <ng-container *ngIf="currentEstimateVersion.status !== 'canceled' && sentMode">
              <ng-container *ngIf="getDepositValues() let depositValues">
                <div class="d-flex justify-content-between" *ngIf="depositValues.paid > 0">
                  <div class="total paid">Paid</div>
                  <div class="total paid">${{depositValues.paid.toFixed(2)}}</div>
                </div>
                <div class="d-flex justify-content-between"
                     *ngIf="depositValues.pending > 0 && currentEstimateVersion.status !== 'accepted'"
                >
                  <div class="total pending">Pending</div>
                  <div class="total pending">${{depositValues.pending.toFixed(2)}}</div>
                </div>
                <div class="d-flex justify-content-between" *ngIf="depositValues.pending < 0 && !estimate.invoiceId">
                  <div class="total refund">Refund</div>
                  <div class="total refund">-${{(-depositValues.pending).toFixed(2)}}</div>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="paidAmount && !sentMode && currentEstimateVersion.status !== 'canceled'">
              <div class="d-flex justify-content-between" *ngIf="paidAmount > 0">
                <div class="total paid">Paid</div>
                <div class="total paid">${{paidAmount.toFixed(2)}}</div>
              </div>
              <ng-container *ngIf="currentEstimateVersion?.depositAmount">
                <ng-container *ngIf="((currentEstimateVersion?.depositAmount! + (estimate.sSurchargeSum ?? 0)) - paidAmount!) let pending">
                  <div class="d-flex justify-content-between" *ngIf="pending > 0">
                    <div class="total pending">Pending</div>
                    <div class="total pending">${{pending?.toFixed(2)}}</div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="currentEstimateVersion.depositAmount">
                <ng-container *ngIf="((currentEstimateVersion.depositAmount + (estimate.sSurchargeSum ?? 0)) - paidAmount!) let refund">
                  <div class="d-flex justify-content-between" *ngIf="refund < 0">
                    <div class="total refund">Refund</div>
                    <div class="total refund">-${{(-refund)?.toFixed(2)}}</div>
                  </div>
                </ng-container>
                <div class="divider"></div>
                <div class="d-flex justify-content-between" *ngIf="currentEstimateVersion.surcharge && !sentMode">
                  <div class="total">Surcharge</div>
                  <div>On</div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-template #uid>
  <div class="d-flex flex-column gap--4">
    <div class="d-flex">
      <div class="uid-label">ESTIMATE:&nbsp;</div>
      <div class="uid-data">{{ estimate.uid ? estimate.uid + ' - ' + (currentEstimateVersion.subUid ?? nextSubUid()) : '' }}</div>
    </div>
    <ng-container *ngIf="date$ | async let date">
      <div class="d-flex">
        <div class="uid-label">DATE:&nbsp;</div>
        <div class="uid-data">{{date.createdDate}}</div>
      </div>
      <div class="d-flex">
        <div class="uid-label">TIME:&nbsp;</div>
        <div class="uid-data">{{date.createdTime}}</div>
      </div>
    </ng-container>
  </div>
</ng-template>
